export default {
  'en-US': {
    currency: {
      style: 'currency', currency: 'USD'
    }
  },
  'ja-JP': {
    currency: {
      style: 'currency', currency: 'JPY', currencyDisplay: 'symbol'
    }
  },
  'es': {
    currency: {
      style: 'currency', currency: 'CLP', currencyDisplay: 'symbol'
    }
  }
}